import { render, staticRenderFns } from "./comparison_tab.vue?vue&type=template&id=acf2fe74&scoped=true"
import script from "./comparison_tab.vue?vue&type=script&lang=js"
export * from "./comparison_tab.vue?vue&type=script&lang=js"
import style0 from "./comparison_tab.vue?vue&type=style&index=0&id=acf2fe74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf2fe74",
  null
  
)

export default component.exports